import React, { useEffect, useRef, useState } from "react";
import Button from "../../../components/reusable/Button/Button";
import TableList from "../../../components/TableList/TableList";
import { useAppDispatch } from "../../../app/store";
import PageLoader from "../../../components/reusable/PageLoader/PageLoader";
import { useSelector } from "react-redux";
import { dashboardAPI } from "../../../Api/dashboardAPI";
import { Alumno } from "../../../types/alumnos";
import { getDetalleDeAlumno } from "../../../features/Dashboard/AsyncThunks/alumnos/getDetalleDeAlumno";
import { getAlumnosRegistrados } from "../../../features/Dashboard/AsyncThunks/alumnos/getAlumnosRegistrados";
import ModalConfirmation from "../../../components/reusable/ModalConfirmation/ModalConfirmation";
import { toastError, toastSuccess } from "../../../utils/toast";
import Pagination from "../../../components/reusable/Pagination/Pagination";
import SlRadio from "@shoelace-style/shoelace/dist/react/radio";
import {
  selectAlumnosRegistrados,
  selectRegistradosCurrentPage,
  setRegistradosCurrentPage,
} from "../../../features/Dashboard/Slices/alumnosSlice";
import BuscadorAlumnosRegistrados from "../../../components/BuscadorAlumnosRegistrados";
import SlButton from "@shoelace-style/shoelace/dist/react/button";
import SlDrawer from "@shoelace-style/shoelace/dist/react/drawer";
import SlIcon from "@shoelace-style/shoelace/dist/react/icon";
import CopyTooltip from "../../../components/CopyTooltip/CopyTooltip";
import {
  selectGlobalFlags,
  setAlumnoDetailLoading,
  setDrawerInicializar,
} from "../../../features/Dashboard/Slices/globalFlagsSlice";
import useAuth from "../../../hooks/useAuth";
import { postBorrarTodosLosAlumnos } from "../../../features/Dashboard/AsyncThunks/alumnos/getAlumnosInicializados";

function AlumnosRegistrados() {
  const [loading, setLoading] = useState(false);
  const alumnosRegistrados = useSelector(selectAlumnosRegistrados);
  const registradosCurrentPage = useSelector(selectRegistradosCurrentPage);
  const [alumnoSelected, setAlumnoSelected] = useState<Alumno | undefined>();
  const { alumnoDetailLoading } = useSelector(selectGlobalFlags);
  const { hasPermission, permissions, user } = useAuth();
  const resetCursosFijadosRef = useRef(false);
  const resetTodosCursosFijadosRef = useRef(false);
  const confirmationModalInitialState = {
    show: false,
    title: "",
    dialog: "",
    onConfirm: () => {},
    showSwitch: false,
    switchLabel: "",
    switchValue: false,
    onSwitchChange: () => {},
  };
  const dispatch = useAppDispatch();
  const [confirmationModal, setConfirmationModal] = useState(
    confirmationModalInitialState
  );
  const clearConfirmationModal = () => {
    setConfirmationModal(confirmationModalInitialState);
  };

  const clearSwitchFijadas = () => {
    resetCursosFijadosRef.current = false;
    resetTodosCursosFijadosRef.current = false;
  };

  /* -------------------------------------------------------------------------- */
  /*                               LÓGICA PAGINADO                              */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    getAlumnosRegistradosPaginadoInicial();
  }, []);

  const getAlumnosRegistradosPaginadoInicial = async () => {
    await dispatch(setRegistradosCurrentPage(1));
    await getAlumnosRegistradosPaginado();
  };

  const getAlumnosRegistradosPaginado = async () => {
    setLoading(true);
    await dispatch(getAlumnosRegistrados());
    setLoading(false);
  };

  const handleChangePage = async (newPage: number) => {
    await dispatch(setRegistradosCurrentPage(newPage));
    await getAlumnosRegistradosPaginado();
  };
  /* -------------------------------------------------------------------------- */
  /*                               ACCIONES ALUMNO                              */
  /* -------------------------------------------------------------------------- */
  const resetearAlumno = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      if (alumnoSelected) {
        const { id_persona } = alumnoSelected;
        console.log("reset cursos fijados :>> ", resetCursosFijadosRef.current);
        const res = await dashboardAPI.resetearAlumno(
          id_persona,
          resetCursosFijadosRef.current
        );
        toastSuccess(JSON.stringify(res));
        getAlumnosRegistradosPaginadoInicial();
      } else {
        throw new Error("No se encuentra id_persona");
      }
    } catch (error) {
      toastError("Ocurrió un error inesperado...");
      console.log("error :>> ", error);
    } finally {
      clearSwitchFijadas();
      setLoading(false);
    }
  };

  const borrarAlumno = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      if (alumnoSelected) {
        const { id_persona } = alumnoSelected;
        const res = await dashboardAPI.eliminarAlumno(id_persona);
        toastSuccess(JSON.stringify(res));
        getAlumnosRegistradosPaginadoInicial();
      } else {
        throw new Error("No se encuentra id_persona");
      }
    } catch (error) {
      toastError("Ocurrió un error inesperado...");
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const verDetalleDeAlumno = async () => {
    if (alumnoSelected) {
      const { id_alumno_carrera } = alumnoSelected;
      await dispatch(getDetalleDeAlumno(id_alumno_carrera));
    }
  };
  const verDetalleDeAlumnoById = async (id: number) => {
    if (id) {
      dispatch(setAlumnoDetailLoading(id));
      const res = await dispatch(getDetalleDeAlumno(id));
      if (res.payload) {
        dispatch(setAlumnoDetailLoading(null));
      }
    }
  };

  const actualizarOfertas = async () => {
    setLoading(true);
    try {
      if (alumnoSelected) {
        const res = await dashboardAPI.actualizarOferta(
          alumnoSelected.id_alumno_carrera
        );
        toastSuccess(JSON.stringify(res));
      }
    } catch (error) {
      toastError("Ocurrió un error inesperado...");
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const actualizarInscripciones = async () => {
    setLoading(true);
    try {
      if (alumnoSelected) {
        const res = await dashboardAPI.actualizarInscripciones(
          alumnoSelected.id_alumno_carrera
        );
        toastSuccess(JSON.stringify(res));
      }
    } catch (error) {
      toastError("Ocurrió un error inesperado...");
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const invalidarSemaforo = async () => {
    setLoading(true);
    try {
      if (alumnoSelected) {
        const res = await dashboardAPI.invalidarSemaforo(
          alumnoSelected.id_persona
        );
        toastSuccess(JSON.stringify(res));
      }
    } catch (error) {
      toastError("Ocurrió un error inesperado...");
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const enviarLogout = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      if (alumnoSelected) {
        const res = await dashboardAPI.logoutIndividual(
          alumnoSelected.id_persona
        );
        toastSuccess(JSON.stringify(res));
      }
    } catch (error) {
      toastError("Ocurrió un error inesperado...");
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const vencerOferta = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      if (alumnoSelected) {
        const res = await dashboardAPI.vencerOferta(
          alumnoSelected.id_alumno_carrera
        );
        toastSuccess(JSON.stringify(res));
      }
    } catch (error) {
      toastError("Ocurrió un error inesperado...");
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const invalidarOferta = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      if (alumnoSelected) {
        const res = await dashboardAPI.invalidarOferta(
          alumnoSelected.id_alumno_carrera
        );
        toastSuccess(JSON.stringify(res));
      }
    } catch (error) {
      toastError("Ocurrió un error inesperado...");
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const resetearAlumnosRegistrados = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      console.log(
        "resetear todos los cursos fijados :>> ",
        resetTodosCursosFijadosRef.current
      );
      const res = await dashboardAPI.resetearAlumnosRegistrados(
        resetTodosCursosFijadosRef.current
      );
      toastSuccess(JSON.stringify(res));
    } catch (error) {
      toastError();
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const invalidarSemaforoGlobal = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      const res = await dashboardAPI.invalidarSemaforoGlobal();
      toastSuccess(JSON.stringify(res));
    } catch (error) {
      toastError();
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const vencerOfertaGlobal = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      const res = await dashboardAPI.vencerOfertaGlobal();
      toastSuccess(JSON.stringify(res));
    } catch (error) {
      toastError();
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const invalidarOfertaGlobal = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      const res = await dashboardAPI.invalidarOfertaGlobal();
      toastSuccess(JSON.stringify(res));
    } catch (error) {
      toastError();
      console.log("error :>> ", error);
    }
    setLoading(false);
  };

  const BorrarTodosLosAlumnos = async () => {
    setLoading(true);
    clearConfirmationModal();
    try {
      await dispatch(postBorrarTodosLosAlumnos());
      await getAlumnosRegistradosPaginadoInicial();
      
    } catch (error) {
      console.log("error :>> ", error);
    }
    setLoading(false);
  };
  /* -------------------------------------------------------------------------- */
  /*                                   RENDER                                   */
  /* -------------------------------------------------------------------------- */

  const alumnoAccionesBotones = [
    {
      action: () => resetearAlumno(),
      label: "Resetear",
      theme: "blue",
      confirmationTitle: `¿Desea resetear al alumno ${alumnoSelected?.alumno}?`,
      confirmationDialog: "",
      variant: "default",
      icon: "recycle",
      disabled: !hasPermission("alumnos", "resetear"),
      showSwitch: true,
      switchLabel: "Resetear cursos fijados",
      switchValue: resetCursosFijadosRef.current,
      onSwitchChange: () => {
        const newValue = !resetCursosFijadosRef.current;
        resetCursosFijadosRef.current = newValue;
        console.log(
          "resetCursosFijadosRef.current :>> ",
          resetCursosFijadosRef.current
        );
      },
    },
    {
      action: () => borrarAlumno(),
      label: "Borrar",
      theme: "red",
      confirmationTitle: `¿Desea borrar al alumno ${alumnoSelected?.alumno}?`,
      confirmationDialog: "",
      variant: "danger",
      icon: "trash3",
      disabled: !hasPermission("alumnos", "borrar"),
    },
    {
      action: () => verDetalleDeAlumno(),
      label: "Detalle",
      theme: "yellow",
      variant: "success",
      icon: "journal-text",
      disabled: !hasPermission("alumnos", "detalle"),
    },
    {
      action: () => actualizarOfertas(),
      label: "Actualizar ofertas",
      theme: "green",
      variant: "primary",
      icon: "arrow-clockwise",
      disabled: !hasPermission("alumnos", "actualizar_ofertas"),
    },
    {
      action: () => actualizarInscripciones(),
      label: "Actualizar inscripciones",
      theme: "blue",
      variant: "primary",
      icon: "arrow-clockwise",
      disabled: !hasPermission("alumnos", "actualizar_inscripciones"),
    },
    {
      action: () => invalidarSemaforo(),
      label: "Invalidar semáforo",
      theme: "red",
      variant: "warning",
      icon: "sign-stop-lights",
      disabled: !hasPermission("alumnos", "invalidar_semaforos"),
    },
    {
      action: () => invalidarOferta(),
      label: "Invalidar oferta",
      theme: "yellow",
      confirmationTitle: `¿Desea inválidar la oferta al alumno ${alumnoSelected?.alumno}?`,
      confirmationDialog: "",
      variant: "warning",
      icon: "card-list",
      disabled: !hasPermission("alumnos", "invalidar_oferta"),
    },
    {
      action: () => vencerOferta(),
      label: "Vencer oferta",
      theme: "red",
      confirmationTitle: `¿Desea vencer la oferta al alumno ${alumnoSelected?.alumno}?`,
      confirmationDialog: "",
      variant: "danger",
      icon: "sign-stop",
      disabled: !hasPermission("alumnos", "vencer_oferta"),
    },
    {
      action: () => enviarLogout(),
      label: "Enviar logout",
      theme: "blue",
      confirmationTitle: `¿Desea desloguear al alumno ${alumnoSelected?.alumno}?`,
      confirmationDialog: "",
      variant: "default",
      icon: "door-closed",
      disabled: !hasPermission("alumnos", "logout"),
    },
  ];

  return (
    <>
      {loading && <PageLoader />}
      <ModalConfirmation
        show={confirmationModal.show}
        onClose={() => {
          clearSwitchFijadas();
          clearConfirmationModal();
        }}
        onConfirm={confirmationModal.onConfirm}
        title={confirmationModal.title}
        message={confirmationModal.dialog}
        showSwitch={confirmationModal?.showSwitch}
        switchLabel={confirmationModal?.switchLabel}
        switchValue={confirmationModal?.switchValue}
        onSwitchChange={confirmationModal?.onSwitchChange}
      />

      <div className="bg-white p-6 rounded-lg border-2 border-cardBorder col-span-1 flex flex-col">
        <h4 className="font-semibold text-textSecondary mb-3 text-[16px]">
          Alumnos
        </h4>
        <div className="flex flex-col gap-2 mt-auto">
          <div className="flex items-center justify-between">
            <span className="text-sm text-textSecondary">Total</span>
            <span className="text-xl font-semibold text-textPrimary">
              {alumnosRegistrados.totalCount}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="flex items-center gap-2 text-sm text-textSecondary">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full rounded-full bg-success opacity-75 animate-ping"></span>
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-success"></span>
              </span>
              Online
            </span>
            <span className="text-xl font-semibold text-success_dark">
              {alumnosRegistrados.onlineCount}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg border-2 border-cardBorder col-span-4 flex flex-col">
        <h4 className="font-semibold text-textSecondary mb-3 text-[16px]">
          Acciones globales
        </h4>
        <div className="flex flex-wrap gap-2">
          <button
            className="text-textPrimary font-bold hover:underline border-2 border-cardBorder px-3 py-1 rounded-lg hover:bg-cardBorder"
            onClick={getAlumnosRegistradosPaginadoInicial}
            disabled={!hasPermission("alumnos", "actualizar_listado")}
          >
            Actualizar listado
          </button>

          <button
            className="text-textPrimary font-bold hover:underline border-2 border-cardBorder px-3 py-1 rounded-lg hover:bg-cardBorder disabled:bg-cardBorder disabled:text-textSecondary"
            onClick={() => {
              setConfirmationModal({
                ...confirmationModalInitialState,
                show: true,
                onConfirm: resetearAlumnosRegistrados,
                title: "¿Desea resetear todos los alumnos?",
                dialog: "Todos los alumnos se verán afectados",
                showSwitch: true,
                switchLabel: "Resetear todos los cursos fijados",
                switchValue: resetTodosCursosFijadosRef.current,
                onSwitchChange: () => {
                  const newValue = !resetTodosCursosFijadosRef.current;
                  resetTodosCursosFijadosRef.current = newValue;
                  console.log(
                    "resetTodosCursosFijadosRef.current :>> ",
                    resetTodosCursosFijadosRef.current
                  );
                },
              });
            }}
            disabled={!hasPermission("alumnos", "resetear_todos")}
          >
            Resetear todos
          </button>

          <button
            className="text-textPrimary font-bold hover:underline border-2 border-cardBorder px-3 py-1 rounded-lg hover:bg-cardBorder disabled:bg-cardBorder disabled:text-textSecondary"
            onClick={() => {
              setConfirmationModal({
                ...confirmationModalInitialState,
                show: true,
                onConfirm: invalidarSemaforoGlobal,
                title: "Desea invalidar semaforo global?",
                dialog: "",
              });
            }}
            disabled={!hasPermission("alumnos", "invalidar_semaforo_global")}
          >
            Invalidar semaforo global
          </button>

          <button
            className="text-textPrimary font-bold hover:underline border-2 border-cardBorder px-3 py-1 rounded-lg hover:bg-cardBorder disabled:bg-cardBorder disabled:text-textSecondary"
            onClick={() => {
              setConfirmationModal({
                ...confirmationModalInitialState,
                show: true,
                onConfirm: invalidarOfertaGlobal,
                title: "¿Desea invalidar oferta global?",
                dialog: "",
              });
            }}
            disabled={!hasPermission("alumnos", "invalidar_oferta_global")}
          >
            Invalidar oferta global
          </button>

          <button
            className="text-textPrimary font-bold hover:underline border-2 border-cardBorder px-3 py-1 rounded-lg hover:bg-cardBorder disabled:bg-cardBorder disabled:text-textSecondary"
            onClick={() => {
              setConfirmationModal({
                ...confirmationModalInitialState,
                show: true,
                onConfirm: vencerOfertaGlobal,
                title: "¿Desea vencer oferta global?",
                dialog: "",
              });
            }}
            disabled={!hasPermission("alumnos", "vencer_oferta_global")}
          >
            Vencer oferta global
          </button>
          <Button
            theme="danger"
            size="small"
            iconName="trash3"
            disabled={!hasPermission("alumnos", "borrar_todos_ipo")}
            onClick={() => {
              setConfirmationModal({
                show: true,
                onConfirm: BorrarTodosLosAlumnos,
                title: `¿Desea borrar todos los alumnos?`,
                dialog: "Esta acción eliminará todos los alumnos de la base de datos",
                showSwitch: false,
                switchLabel: "",
                switchValue: false,
                onSwitchChange: () => {},
              });
            }}
          >
            Borrar Todos los alumnos
          </Button>
          <Button
            theme="primary"
            size="small"
            iconName="arrow-bar-left"
            disabled={
              !hasPermission(
                "alumnos",
                "panel_de_inicializacion_por_mail_o_ipo"
              )
            }
            onClick={() => dispatch(setDrawerInicializar(true))}
          >
            Inicializar alumnos
          </Button>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg border-2 border-cardBorder col-span-5 flex flex-col">
        <h4 className="font-semibold text-textSecondary mb-3 text-[16px]">
          Listado
        </h4>

        <div className="flex gap-10">
          <BuscadorAlumnosRegistrados />
        </div>
        <div className="h-auto mt-4">
          <div>
            <TableList
              page="alumnos"
              list={alumnosRegistrados.alumnos}
              customColumns={[
                {
                  columnTitle: "Select",
                  boxContent: (alumno) => {
                    return (
                      <div className="flex w-full justify-center">
                        <SlRadio
                          className="pl-2"
                          value="1"
                          checked={
                            alumnoSelected?.id_persona === alumno?.id_persona
                          }
                          onClick={() => setAlumnoSelected(alumno)}
                        />
                      </div>
                    );
                  },
                },
                {
                  columnTitle: "Details",
                  boxContent: (alumno) => {
                    return (
                      <div className="flex w-full justify-center">
                        <SlIcon
                          className={`text-[#a0a0a0] hover:text-[#6e6e6e] hover:cursor-pointer ${
                            alumnoDetailLoading === alumno.id_alumno_carrera
                              ? "animate-ping"
                              : ""
                          }`}
                          name="eye"
                          style={{ fontSize: "18px" }}
                          onClick={() =>
                            verDetalleDeAlumnoById(alumno?.id_alumno_carrera)
                          }
                        ></SlIcon>
                      </div>
                    );
                  },
                },
              ]}
            />
          </div>

          {/* <table className="border-collapse table-auto w-full">
            <thead>
              <tr>
                <th>Id persona</th>
                <th>Nombre</th>
                <th>Email</th>
                <th>Carrera</th>
                <th>Estado</th>
                <th>Oferta</th>
                <th>Inscripciones</th>
              </tr>
            </thead>
            <tbody>
              {alumnosRegistrados.alumnos &&
                [...alumnosRegistrados.alumnos]
                  .sort((a: Alumno, b: Alumno) =>
                    a.alumno.localeCompare(b.alumno)
                  )
                  .map((alumno) => (
                    <tr className="odd:bg-white even:bg-grey">
                      <td className="">
                        {alumno.id_persona}
                      </td>
                      <td className="flex items-center gap-2">
                        <p
                          className="hover:underline hover:cursor-pointer hover:font-semibold"
                          onClick={() => setAlumnoSelected(alumno)}
                        >
                          {alumno.alumno}
                        </p>
                        <div
                          className={`w-2 h-2 rounded-full ${
                            alumno.online === "ONLINE"
                              ? "bg-[green] animate-pulse"
                              : "bg-grey"
                          }`}
                        ></div>
                      </td>

                      <td className="">{alumno.mails}</td>
                      <td className="">{alumno.carrera}</td>
                      <td className="text-[10px]">{alumno.estado}</td>
                      <td className="">{alumno.oferta}</td>
                      <td className="">{alumno.inscripciones}</td>
                    </tr>
                  ))}
            </tbody>
          </table> */}

          <Pagination
            totalCount={alumnosRegistrados.totalCount}
            onPageChange={handleChangePage}
            currentPage={registradosCurrentPage}
          />
        </div>
      </div>

      <SlDrawer
        label="Alumno seleccionado"
        open={alumnoSelected ? true : false}
        onSlAfterHide={() => setAlumnoSelected(undefined)}
      >
        {alumnoSelected && (
          <div>
            <div className="flex flex-col items-center justify-center py-4 bg-[#eee] rounded-lg mb-4">
              <SlIcon
                name="person-video2"
                style={{ fontSize: "32px" }}
              ></SlIcon>
              <h3 className="text-center text-lg uppercase">
                {alumnoSelected?.alumno}
              </h3>
              <div className="text-xs">
                <CopyTooltip textToCopy={alumnoSelected.mails}>
                  <p className="font-semibold hover:underline">
                    {alumnoSelected.mails.trim()}
                  </p>
                </CopyTooltip>

                <p className="text-center text-nowrap">
                  Id alumno carrera:{" "}
                  <CopyTooltip
                    textToCopy={String(alumnoSelected?.id_alumno_carrera)}
                  >
                    <span className="font-semibold hover:underline">
                      {alumnoSelected?.id_alumno_carrera}
                    </span>
                  </CopyTooltip>
                </p>
                <p className="text-center">
                  Id persona:{" "}
                  <CopyTooltip textToCopy={String(alumnoSelected?.id_persona)}>
                    <span className="font-semibold hover:underline hover:cursor-default active:cursor-copy">
                      {alumnoSelected?.id_persona}
                    </span>
                  </CopyTooltip>
                </p>
              </div>
            </div>

            <div className="space-y-4">
              {alumnoAccionesBotones.map(
                ({
                  action,
                  label,
                  confirmationDialog,
                  confirmationTitle,
                  variant = "default",
                  disabled,
                  icon = "",
                  showSwitch = false,
                  switchLabel = "",
                  switchValue = false,
                  onSwitchChange = () => {},
                }: any) => (
                  <SlButton
                    outline
                    variant={variant}
                    size="medium"
                    className="w-full"
                    disabled={disabled}
                    onClick={
                      confirmationTitle
                        ? () => {
                            setConfirmationModal({
                              show: true,
                              onConfirm: action,
                              title: confirmationTitle,
                              dialog: confirmationDialog,
                              showSwitch: showSwitch,
                              switchLabel: switchLabel,
                              switchValue: switchValue,
                              onSwitchChange: onSwitchChange,
                            });
                          }
                        : action
                    }
                    // label={label}
                    // theme={theme}
                  >
                    <SlIcon
                      slot="prefix"
                      name={icon}
                      style={{ fontSize: "20px" }}
                    ></SlIcon>
                    {label}
                  </SlButton>
                )
              )}
            </div>
          </div>
        )}
      </SlDrawer>
    </>
  );
}

export default AlumnosRegistrados;
